import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import {
  PageMembershipMatchingRulesReportsProps,
} from '../../../types/PageMembershipMatchingRuleReportsList.types';
import {
  ReportsList,
} from '../../../_lib/components/ReportsList/ReportsList';
import {
  ReportsListActionBar,
} from
  '../../../_lib/components/ReportsListActionBar/ReportsListActionBar';
import { useSonTranslation } from '../../../translation/useSonTranslation';

function PageMembershipMatchingRuleReports(props: PageMembershipMatchingRulesReportsProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  return (
    <>
      <ReportsListActionBar
        form={props.executeMatcher}
        heading={t('triggerMatcherExecutionDryRun')}
        headline={t('interactions.executeMatcher.form.headline')}
        messageSuccess={t('interactions.executeMatcher.form.messageSuccess')}
        messageSending={t('interactions.executeMatcher.form.messageSending')}
        messageFail={t('interactions.executeMatcher.form.messageFail')}
        customErrorTypeMessages={{
          jobAlreadyInProgress: t('interactions.executeMatcher.form.status.jobAlreadyInProgress'),
        }}
        hintMessage={t('interactions.executeMatcher.form.hint')}
        checkBoxLabel={t('interactions.executeMatcher.form.checkBoxDryRun')}
      />
      <ReportsList {...props} />
    </>
  );
}

export const PageMembershipMatchingRuleReportsDefaultView = asFetchableView(PageMembershipMatchingRuleReports);
export type PageMembershipMatchingRuleReportsDefaultView = ComponentProps<typeof PageMembershipMatchingRuleReports>;
